import Button from '@base/Button/Button';
import H4 from '@base/H4/H4';
import Image from '@base/Image';
import P1 from '@base/P1/P1';
import Paper from '@base/Paper/Paper';
import styled from '@emotion/styled';
import useWindowSize from '@hooks/useWindowSize';
import { Spacings } from '@styles/index';
import { localStorageAvailable } from '@utils/localStorage';
import { useEffect, useState } from 'react';

const Wrapper = styled(Paper)`
  grid-column: span 18;
  padding: ${Spacings.SPACING_6B};
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${Spacings.SPACING_6B};
`;

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ImageWrapper = styled.div`
  margin-right: ${Spacings.SPACING_6B};
`;

const StyledButton = styled(Button)`
  width: 140px;
  border-radius: ${Spacings.SPACING_1B};
`;

const StyledH4 = styled(H4)`
  margin-bottom: ${Spacings.SPACING_2};
`;

const StyledP1 = styled(P1)`
  color: var(--color-text-secondary);
`;

const RevampIntroBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (localStorageAvailable()) {
      const hideRavampIntroBanner =
        localStorage.getItem('hideRavampIntroBanner') ?? null;
      setShowBanner(!hideRavampIntroBanner);
    }
  }, []);

  const { isMobile } = useWindowSize();

  if (!showBanner || isMobile) {
    return null;
  }

  const handleCTAClick = () => {
    if (localStorageAvailable()) {
      localStorage.setItem('hideRavampIntroBanner', true);
      setShowBanner(false);
    }
  };

  return (
    <Wrapper>
      <InfoWrapper>
        <ImageWrapper>
          <Image
            src="/test-revamp/intro-icon-a-plus.png"
            height={72}
            width={72}
            alt="test-revamp-intro"
          />
        </ImageWrapper>
        <div>
          <StyledH4>Introducing an improved test view on web</StyledH4>
          <StyledP1>
            Get a more realistic test experience that matches your final exam
          </StyledP1>
        </div>
      </InfoWrapper>
      <div>
        <StyledButton
          label="Got it"
          variant="hollow"
          color="black"
          maxHeight="sm"
          onClick={handleCTAClick}
        />
      </div>
    </Wrapper>
  );
};

export default RevampIntroBanner;
